import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getWorkOrderRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/work-orders/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/work-orders/:id?includeSteps=true' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getWorkOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 41,
        "number": "1024:1",
        "status": "Entered",
        "moItem": {
            "id": 385,
            "description": "Bike, 26 inch"
        },
        "location": {
            "id": 20,
            "name": "Manufacturing"
        },
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "customer": {
            "id": 7,
            "name": "Sam Ash"
        },
        "class": {
            "id": 1,
            "name": "None"
        },
        "category": {
            "id": 12,
            "name": "Assembly"
        },
        "priority": "3-Normal",
        "quantityOrdered": 1,
        "quantityTarget": 1,
        "quantityScrapped": 0,
        "cost": "0",
        "note": "",
        "dateCreated": "2021-05-14T15:49:18.000-0600",
        "dateScheduled": "2021-05-14T15:49:08.160-0600",
        "dateScheduledToStart": "2021-05-14T15:49:08.160-0600",
        "dateStarted": null,
        "dateFinished": null,
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2021-05-14T15:49:18.744-0600"
        },
        "assignedUsers": [
            {
                "id": 1,
                "name": "admin",
                "description": "Administrator"
            }
        ],
        "woItems": [
            {
                "id": 101,
                "part": {
                    "id": 80,
                    "name": "BK100",
                    "description": "New to Biking Kit"
                },
                "type": {
                    "id": 10,
                    "name": "Finished Good"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "quantity": "1",
                "quantityUsed": "0",
                "quantityScrapped": "0",
                "cost": "0",
                "description": "New to Biking Kit",
                "destLocation": {
                    "id": 23,
                    "name": "Finished Goods"
                },
                "consumeItems": []
            },
            {
                "id": 102,
                "part": {
                    "id": 52,
                    "name": "PM100",
                    "description": "Entry Bike Pump"
                },
                "type": {
                    "id": 20,
                    "name": "Raw Good"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "quantity": "1",
                "quantityUsed": "0",
                "quantityScrapped": "0",
                "cost": "0",
                "description": "Entry Bike Pump",
                "consumeItems": [
                    {
                        "id": 1,
                        "part": {
                            "id": 52,
                            "name": "PM100",
                            "description": "Entry Bike Pump"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "quantity": "1",
                        "originalQuantity": "1",
                        "short": false
                    }
                ]
            }
        ],
        "steps": [
            {
                "id": 7,
                "name": "Assemble frame",
                "description": "Attach the wheels to the frame.",
                "url": "",
                "details": "",
                "sortOrder": 1,
                "quantityReady": 0,
                "quantityFulfilled": 0,
                "dateFirstReady": null,
                "dateLastFulfilled": null
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'get-work-order',
    title: 'Get a work order',
    description: 'Retrieves the details of an existing work order. You only need to provide the unique work order ID. ' +
        'Add the optional includeSteps=true query parameter to also return the work instruction steps; ' +
        'when the parameter is omitted the steps are excluded from the response. ' +
        'Requires the WO_VIEW access right. Work orders in location groups the user has read-only access to are ' +
        'returned; a 403 is returned only when the user has no access at all to the work order\'s location group. ' +
        'Returns 404 if the work order is not found.',
    endpoint: {
        verb: 'GET',
        path: '/work-orders/:id',
        tooltip: 'Get a work order',
    },
    attributes: [],
    requestObject: getWorkOrderRequest,
    responseObject: getWorkOrderResponse,
};

export default data;